import { FC, ReactElement, useMemo } from 'react'
import { CryptoRewardsPanePreset } from 'components/features/rewards/rewardsPane/components/CryptoRewardsPanePreset/CryptoRewardsPanePreset'
import { getBuyOrderSuccessResultOrNullSelector } from 'components/features/rewards/rewardsPane/store/selectors/orderState'
import { useStoreSelector } from 'helpers/reactReduxHelpers'
import {
  CryptoRewardsOrderSuccessResultWarning,
} from 'components/features/rewards/rewardsPane/components/CryptoRewardsOrderSuccessResultWarning/CryptoRewardsOrderSuccessResultWarning'
import { CryptoCurrencyLogo } from 'components/features/rewards/rewardsPane/containers/CryptoCurrencyLogo/CryptoCurrencyLogo'
import { getCryptoRewardsPaneProgressPercentsStateSelector } from 'components/features/rewards/rewardsPane/store/selectors/paneState'
import { OrderSuccessResultWithMeta } from 'components/features/rewards/rewardsPane/types/orderResult'
import { FLOATING_PANE_CRYPTO_REWARDS_BUY_MODE } from 'components/features/rewards/rewardsPane/constants/paneState'
import {
  CryptoRewardsSuccessInvestmentImagePreset,
} from 'components/features/rewards/rewardsPane/components/CryptoRewardsSuccessInvestmentImagePreset/CryptoRewardsSuccessInvestmentImagePreset'

import styles from 'components/features/rewards/rewardsPane/containers/CryptoRewardsBuyPane/CryptoRewardsBuySuccessStep/CryptoRewardsBuySuccessStep.styl'

type CryptoRewardsBuySuccessStepProps = {
  onClose: () => void
}

type CryptoRewardsBuySuccessProps = CryptoRewardsBuySuccessStepProps & {
  investmentOrderResult: OrderSuccessResultWithMeta<typeof FLOATING_PANE_CRYPTO_REWARDS_BUY_MODE>
}

export const CryptoRewardsBuySuccess: FC<CryptoRewardsBuySuccessProps> = ({ investmentOrderResult, onClose }): ReactElement => {
  const paneProgressPercent = useStoreSelector(getCryptoRewardsPaneProgressPercentsStateSelector)
  const { currencyId } = investmentOrderResult

  const successInvestmentIcon = useMemo<ReactElement>(() => {
    const cryptoCurrencyLogo = <CryptoCurrencyLogo currencyId={ currencyId } />

    return (
      <CryptoRewardsSuccessInvestmentImagePreset>
        { cryptoCurrencyLogo }
      </CryptoRewardsSuccessInvestmentImagePreset>
    )
  }, [currencyId])
  const notice = useMemo<ReactElement>(() => {
    return (
      <div className={ styles.notice }>
        We’ll let you know as soon as the order goes through.<br />You can track the order on your rewards page.
      </div>
    )
  }, [])

  return (
    <CryptoRewardsPanePreset
      title='Invest Your Rewards Into Crypto'
      subTitle='Success!'
      actionName='Close'
      withFooterCancel={ false }
      onSuccess={ onClose }
      progressBarPercent={ paneProgressPercent }
    >
      <CryptoRewardsOrderSuccessResultWarning
        renderMode={ FLOATING_PANE_CRYPTO_REWARDS_BUY_MODE }
        orderSuccessResult={ investmentOrderResult }
      />
      { successInvestmentIcon }
      { notice }
    </CryptoRewardsPanePreset>
  )
}


export const CryptoRewardsBuySuccessStep: FC<CryptoRewardsBuySuccessStepProps> = ({ onClose }): ReactElement | null => {
  const investmentOrderResult = useStoreSelector(getBuyOrderSuccessResultOrNullSelector)

  if (!investmentOrderResult) {
    return null
  }
  return <CryptoRewardsBuySuccess investmentOrderResult={ investmentOrderResult } onClose={ onClose } />
}
